<template>
  <div>
    <!--  -->
    <FilterBar name="CashFlow" :currency="currency" :filters="filters" @reset="refresh" @filtrer="filtrer" @search="search" @searchUsers="searchUsers" />
    <!--  -->

    <!--  -->
    <div class="relative grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-2 items-start mx-3"  v-if="filters.name == 'CashFlow'">
      <div v-for="(item, index) in CashflowAnalytics" :key="index" class="flex items-center w-full justify-between p-4 gap-2 rounded-lg bg-white shadow-indigo-50 shadow-md">
        <div>
          <h3 class="mt-1 text-xl font-bold text-left" :class="`text-${item.color}`">
            {{ item.totalCash.toFixed(2) }} MAD
          </h3>
        </div>
        <div class="bg-gradient-to-tr w-20 h-20 rounded-full shadow-2xl border-white border-dashed border-2 flex justify-center items-center" :class="`from-${item.color} to-${item.color} shadow-${item.color}`">
          <div>
            <h1 class="text-white text-center text-sm font-semibold capitalize">
              {{ item.status }}
            </h1>
          </div>
        </div>
      </div>
    </div>
    <!--  -->

    <!--  -->
    <div class="min-h-screen flex-1 bg-gray-100 px-3 mt-3 rounded-lg items-center">
      <!--  -->
      <div class="bg-white w-full rounded-lg shadow">
        <!--  -->
        <div class="h-20 py-3 flex items-center border-gray-200 p-6">
          <!--  -->
          <div class="flex">
            <div class="text-2xl font-bold text-black">
              {{ $t('CashFlow') }}
            </div>
          </div>
          <!--  -->

          <!--  -->
          <div class="w-full flex justify-end gap-4 items-center flex-wrap">
            <!--  -->
            <button @click="triggerMultipleValidations()" v-if="currentUser && currentUser.type == 'CEO'" class="flex justify-center items-center gap-1 rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6 text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
              </svg>
              validate
            </button>
            <!--  -->

            <!--  -->
            <router-link to="/cashflow/new" class="flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300">
              <i class="material-icons">add</i> {{ $t('new') }}
            </router-link>
            <!--  -->

            <!--  -->
            <div @click="downloadCashflow" class="ml-2 cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300">
              <i class="material-icons">file_download</i> csv
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div v-if="currentUser && content.length > 0">
          <cash-table ref="childComponentRef" :refresh="refresh" :currentUser="currentUser" :content="content" :headers="headers" name="cashflow" />
        </div>
        <!--  -->

        <!--  -->
        <div class="p-1">
          <!--  -->
          <div class="flex flex-col items-center my-12">
            <!--  -->
            <div v-if="paginate.lastpage > 1" class="flex text-gray-700">
              <!--  -->
              <button @click="prev" v-if="paginate.currentpage > 1" :disabled="paginate.currentpage === 1" class="h-8 w-8 focus:outline-none mr-6 flex justify-center text-black items-center rounded-full bg-gray-200 hover:bg-black hover:text-white cursor-pointer">
                <i class="material-icons"> keyboard_arrow_left </i>
              </button>
              <!--  -->

              <!--  -->
              <div class="flex h-8 font-medium rounded-full bg-gray-200">
                <!--  -->
                <div v-if="paginate.currentpage !== paginate.lastpage" class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full bg-black text-white">
                  {{ paginate.currentpage }}
                </div>
                <!--  -->

                <!--  -->
                <div v-else class="w-8 md:flex justify-center hover:bg-black hover:text-white items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full">
                  <span v-if="paginate.currentpage !== 1"> 1 </span>
                </div>
                <!--  -->

                <!--  -->
                <div v-if="paginate.currentpage >= 1 && paginate.lastpage !== 1" class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full">
                  ...
                </div>
                <!--  -->

                <!--  -->
                <button :class="paginate.currentpage === paginate.lastpage ? 'bg-black  text-white' : ' '" class="w-8 md:flex justify-center items-center hover:bg-black hover:text-white focus:outline-none hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full">
                  {{ paginate.lastpage }}
                </button>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <button v-if="paginate.currentpage < paginate.lastpage" :disabled="paginate.currentpage === paginate.lastpage" class="h-8 w-8 ml-6 focus:outline-none flex justify-center text-black items-center rounded-full bg-gray-200 hover:bg-black hover:text-white cursor-pointer" @click="next">
                <i class="material-icons"> keyboard_arrow_right </i>
              </button>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
</template>

<script>
import FilterBar from '../../components/FilterBar.vue';

export default {
  components: {
    FilterBar,
  },
  data() {
    return {
      idWharhouse: null,
      selectedStatus: null,
      CashflowAnalytics: 0,
      FilterUsers: [],
      currency: null,
      content: [],
      headers: [
        'id',
        'date',
        'AddedBy',
        'libelle',
        'city',
        'fees',
        'TotalAmount',
        'shippingCompany',
        'validated',
        'status',
        'ValidatedBy',
      ],
      IsConverted: ['Oui', 'Non'],
      limit: 10,
      currentUser: null,
      filter: {},
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      filters: {
        name: 'CashFlow',
        elements: {
          search: {
            options: {
              icon: 'search',
              label: 'search',
              class: '',
              hint: 'search cashflow',
            },
            value: null,
            type: 'search',
            validate: {
              trim: true,
              required: false,
              minlength: 0,
            },
          },
          champs: [
            {
              label: 'Est Valide',
              key: 'validated',
              value: null,
              values: ['Oui', 'Non'],
              class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
              type: 'select',
            },

            {
              label: 'Type',
              key: 'type',
              value: null,
              values: ['Auto', 'Manuel'],
              class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
              type: 'select',
            },
            {
              label: 'Status',
              key: 'status',
              value: null,
              values: ['Charge', 'Pending', 'Paid', 'Processed'],
              class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
              type: 'select',
            },
            
          ],
        },
      },
    };
  },
  async mounted() {
    await this.getUser();
    await this.getwharhouseId();
    await this.getCashflow({ limit: this.limit });
    await this.getUsers();
    this.setDataSelect('AddedBy', this.FilterUsers, null);
  },
  computed: {
      warhouseSelected() {
          return this.$store.getters['wharhouse/warhouseSelected'];
      },
  },
  watch: {
    async selectedStatus() {
      const res = await this.$server.find('cashflow', {
        status: this.selectedStatus,
      });

      if (res.content && res.content.results) {
        this.content = res.content.results;
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.content = [];
      }
    },
  },
  methods: {
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then((res) => {
        this.idWharhouse = res;
      });
    },
    async getUser() {
      const res = await this.$server.me('users');
      if (res.content) this.currentUser = res.content;
      else this.currentUser = null;
    },
    async getUsers() {
      const filter = {
        limit: 10,
        countries: await this.warhouseSelected,
        type: ['CEO', 'Manager']
      };
      const res = await this.$server.find('users', filter);
      if (res.content.results)
        this.FilterUsers = res.content.results.filter(
          (item) => item.fullName != 'system',
        );
      else this.FilterUsers = [];
      this.setDataSelect('AddedBy', this.FilterUsers, null);
    },
    async getCashflow(filter) {
      filter.warehouse = this.idWharhouse._id;
      const res = await this.$server.search('cashflow', filter);
      if (res.content && res.content.results) {
        this.content = res.content.results;
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;

        this.CashflowAnalytics = res.content.CashflowAnalytics;

        let total = 0;
        let totalGlobal = 0;

        this.CashflowAnalytics.forEach((item) => {
          if (item.status === 'Pending') {
            total += item.totalCash;
          } else if ( item.status === 'Paid') {
            total -= item.totalCash;
          }
        });

        this.CashflowAnalytics.forEach((item) => {
          if (item.status === 'Pending') {
            totalGlobal += item.totalCash;
          } else if (item.status === 'Charge' || item.status === 'Paid') {
            totalGlobal -= item.totalCash;
          }
        });

        this.CashflowAnalytics.push({ totalCash: total, color: 'orange-600', status: 'Rest', });
        this.CashflowAnalytics.push({ totalCash: totalGlobal, color: 'red-400', status: 'Rest Global', });
      } else {
        this.content = [];
      }
    },
    async refresh() {
      this.getCashflow({ limit: this.limit });
    },
    async reset() {
      await this.getCashflow({ limit: this.limit });
    },
    async search(data) {
      this.filter = { name: data, wharehouse: this.idWharhouse._id };
      const res = await this.$server.find('cashflow', this.filter);
      if (res.content && res.content.results) {
        this.content = res.content.results;
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.content = [];
      }
    },
    async filtrer(data) {
      this.filter = { limit: this.limit };
      if (data.status) this.filter.status = data.status;
      else delete data.status;

      if (data.date) {
        this.filter.date = data.date.map((el) =>
          this.$moment(el).format('Dyyyy-MM-DD'),
        );
      } else delete this.filters.date;

      if (data.validated) this.filter.validated = data.validated;
      else delete data.validated;

      if (data.type) this.filter.type = data.type;
      else delete data.type;
      await this.getCashflow(this.filter);
    },
    async next() {
      this.filter['page'] = ++this.paginate.currentpage;
      this.filter['limit'] = this.limit;
      await this.getCashflow(this.filter);
    },
    async prev() {
      this.filter['page'] = --this.paginate.currentpage;
      this.filter['limit'] = this.limit;
      await this.getCashflow(this.filter);
    },
    setDataSelect(model, data, splice) {
      for (var i = 0; i < this.filters.elements.champs.length; i++) {
        if (
          this.filters.elements.champs[i].type === 'select' &&
          this.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.filters.elements.champs[i].values = data;
          } else {
            this.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    triggerMultipleValidations() {
      this.$refs.childComponentRef.validateMultipleCharge();
    },
    searchUsers: _.debounce(async function (search, event) {
      const filter = {
        limit: 10,
        fullName: search,
        countries: await this.warhouseSelected,
        type: ['CEO', 'Manager'],
      };

      const res = await this.$server.find('users', filter);

      if (res.content.results) this.FilterUsers = res.content.results;
      else this.FilterUsers = [];
      this.setDataSelect('AddedBy', this.FilterUsers, null);
    }, 500),
    async downloadCashflow() {
      this.filter.warehouse = this.idWharhouse._id;

      const res = await this.$server.export('cashflow', this.filter);

      if (res && res.content) {
        const link = window.document.createElement('a');
        link.setAttribute(
          'href',
          `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURI(res.content)}`,
        );
        link.setAttribute('download', 'cashflow.csv');
        link.click();
      }
    },
    roundedTotal(total) {
      return Math.floor(total);
    },
  },
};
</script>
